import { render, staticRenderFns } from "./mobile-nav.vue?vue&type=template&id=4c5545cc&scoped=true"
import script from "./mobile-nav.vue?vue&type=script&lang=js"
export * from "./mobile-nav.vue?vue&type=script&lang=js"
import style0 from "./mobile-nav.vue?vue&type=style&index=0&id=4c5545cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5545cc",
  null
  
)

export default component.exports